module.exports = __webpack_public_path__ + "static/media/blueReceipt.c18a4032.svg";